import { TeamMemberWithOrganizationTeamMembers } from "~/common/utils";

export const getTeamMemberProfileDefaultValues = (
  teamMember?: TeamMemberWithOrganizationTeamMembers,
) => {
  return {
    signature_name: teamMember?.signature_name ?? "",
    preferred_reference: teamMember?.preferred_reference ?? "",
    name: teamMember?.name ?? "",
    last_name: teamMember?.last_name ?? "",
  };
};
